import { render, staticRenderFns } from "./ActiveForm.vue?vue&type=template&id=772e0978"
import script from "./ActiveForm.vue?vue&type=script&lang=js"
export * from "./ActiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports